module.exports = __webpack_public_path__ + "bootleggers_coffee_color_palette.jpg?3b65787a0261b801e523bcbc66fc0bb7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggers_coffee_color_palette.jpg
// module id = 33
// module chunks = 0